import { makeStyles } from '@mui/styles';
import { muiTheme } from '@tassat/payments-themes';

export default makeStyles((theme: typeof muiTheme) => ({
    statContainer: {
        backgroundColor: 'rgba(255,255,255,0.15)',
        marginRight: '.3rem'
    },
    statHeader: {
        backgroundColor: theme?.app?.clientTheme.colors.primaryColorDark,
        color: theme?.app?.applicationColors.enumColors.white || '#FFF',
        fontSize: '.65rem',
        textTransform: 'uppercase' as 'uppercase',
        textAlign: 'center' as 'center',
        padding: '.25rem 0'
    },
    statNumber: {
        width: 'auto' as 'auto',
        color: theme?.app?.applicationColors.enumColors.white || '#FFF',
        fontSize: '1.25rem',
        textAlign: 'center' as 'center',
        borderRadius: '3px',
        margin: '.3rem',
        padding: '.25rem 0'
    },
    statCount: { backgroundColor: 'rgba(255,255,255,0.15)' },
    lockedStatCount: { backgroundColor: 'rgba(250,82,82,0.4)' },
    failedCount: { backgroundColor: theme?.app?.applicationColors.failure || '#FA5252' },
    lockIcon: {
        height: '15px',
        width: '15px',
        marginRight: '.4rem'
    }
}));